import React, { useState, useEffect } from "react";
import SelectOption from "./SelectOption";
import { useHttp } from "../../../../hooks/http";
import { URL_API, _ } from "../../../../utils";

const SelectTyptPrice = (props) => {
  const [options, setOptions] = useState([]);
  const [loading, data, error] = useHttp(
    {
      url: `${URL_API}/pos/master/price`,
    },
    []
  );

  useEffect(() => {
    if (data && data.data) {
      const newData = _.map(data.data, (n) => ({ value: n.code, text: n.name }));
      setOptions(newData);
    }
  }, [data]);

  if (error) {
    console.log("SelectTyptPrice Error:", error);
  }

  return <SelectOption loading={loading} options={options} {...props} />;
};

export default SelectTyptPrice;
